import { render, staticRenderFns } from "./PermitForm.vue?vue&type=template&id=3176a768&"
import script from "./PermitForm.vue?vue&type=script&lang=js&"
export * from "./PermitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports